/**
 * "Test mode" = the user is mid-solve (a solving session, a single question, or
 * a live duel). Proactive server-message UI (pings, the duel-request popup) is
 * suppressed here and flushed on exit. Shared by the ping loop and the popup.
 */
export function isTestModePath(pathname: string): boolean {
  if (pathname.startsWith('/session/') || pathname.startsWith('/question/')) return true;
  // /battle/<duelId> is a live duel; /battle/friends and /battle/leaderboard are not.
  const m = pathname.match(/^\/battle\/([^/]+)$/);
  if (m && m[1] !== 'friends' && m[1] !== 'leaderboard') return true;
  return false;
}
